import { render, staticRenderFns } from "./person_details.vue?vue&type=template&id=53d4df24&"
import script from "./person_details.vue?vue&type=script&lang=js&"
export * from "./person_details.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/planorama/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('53d4df24')) {
      api.createRecord('53d4df24', component.options)
    } else {
      api.reload('53d4df24', component.options)
    }
    module.hot.accept("./person_details.vue?vue&type=template&id=53d4df24&", function () {
      api.rerender('53d4df24', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/sessions/person_details.vue"
export default component.exports